import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { BRAND } from '../config';

const G = '#00C060';
const G_DARK = '#006633';
const BG = '#f0f7f2';
const CARD = '#ffffff';
const BORDER = 'rgba(0, 192, 96, 0.4)';
const SHADOW = '0 2px 12px rgba(0,0,0,0.08)';
const inputStyle = { background: '#f8faf8', borderColor: 'rgba(0,166,81,0.35)', color: '#1a3322', width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid rgba(0,192,96,0.4)', fontSize: '14px' };

const PDVs = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pdvs, setPdvs] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showModal, setShowModal] = useState(false);
  const [selectedPDV, setSelectedPDV] = useState(null);
  const [formData, setFormData] = useState({ name: '', code: '', address: '', city_id: '', has_big_screen: false });
  const [showCityModal, setShowCityModal] = useState(false);
  const [cityForm, setCityForm] = useState({ name: '', code: '' });

  const loadCities = () =>
    api.get('/admin/cities', { params: { brand: BRAND } }).then(r => setCities(r.data)).catch(() => {});

  useEffect(() => {
    if (user?.role !== 'admin' && user?.role !== 'super_admin') { navigate('/dashboard'); return; }
    loadPDVs();
    loadCities();
  }, [user, navigate]);

  const handleCreateCity = async () => {
    if (!cityForm.name.trim() || !cityForm.code.trim()) {
      setMessage({ type: 'danger', text: 'Nom et code obligatoires' });
      return;
    }
    try {
      await api.post('/admin/cities', { ...cityForm, brand: BRAND });
      setMessage({ type: 'success', text: `Ville "${cityForm.name}" créée` });
      setShowCityModal(false);
      setCityForm({ name: '', code: '' });
      loadCities();
    } catch (error) {
      setMessage({ type: 'danger', text: error.response?.data?.detail || 'Erreur lors de la création' });
    }
  };

  const loadPDVs = async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/pdv', { params: { brand: BRAND } });
      setPdvs(r.data);
    } catch {
      setMessage({ type: 'danger', text: 'Erreur lors du chargement des PDV' });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (pdv) => {
    setSelectedPDV(pdv);
    setFormData({ name: pdv.name, code: pdv.code, address: pdv.address || '', city_id: pdv.city_id?.toString() || '', has_big_screen: pdv.has_big_screen || false });
    setShowModal(true);
  };

  const handleCreate = () => {
    setSelectedPDV(null);
    setFormData({ name: '', code: '', address: '', city_id: '', has_big_screen: false });
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      if (selectedPDV) {
        await api.put(`/admin/pdv/${selectedPDV.id}`, { ...formData, brand: BRAND });
        setMessage({ type: 'success', text: 'PDV mis à jour' });
      } else {
        await api.post('/admin/pdv', { ...formData, brand: BRAND });
        setMessage({ type: 'success', text: 'PDV créé' });
      }
      setShowModal(false);
      loadPDVs();
    } catch (error) {
      setMessage({ type: 'danger', text: error.response?.data?.detail || 'Erreur lors de la sauvegarde' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce point de vente ?')) return;
    try {
      await api.delete(`/admin/pdv/${id}`);
      setPdvs(pdvs.filter(p => p.id !== id));
      setMessage({ type: 'success', text: 'PDV supprimé' });
    } catch (error) {
      setMessage({ type: 'danger', text: error.response?.data?.detail || 'Erreur lors de la suppression' });
    }
  };

  if (loading) return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: BG }}>
      <div className="spinner-border" style={{ color: G }} role="status"></div>
    </div>
  );

  return (
    <div className="min-vh-100" style={{ background: BG }}>
      <nav className="navbar navbar-dark sticky-top" style={{ background: '#0a1f0c', padding: '10px 0', borderBottom: `2px solid rgba(0,192,96,0.4)` }}>
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <img src="/logo-white.png" alt="RNP" style={{ width: '46px', height: 'auto' }} />
            <div>
              <div className="fw-bold text-white" style={{ fontSize: '16px' }}>Reaktor Nature Power</div>
              <div style={{ fontSize: '11px', color: G }}>Points de Vente</div>
            </div>
          </div>
          <button onClick={() => navigate('/dashboard')} className="btn btn-sm"
            style={{ background: 'rgba(0,192,96,0.2)', border: `1px solid rgba(0,192,96,0.5)`, color: '#fff' }}>
            <i className="fas fa-arrow-left me-2"></i>Dashboard
          </button>
        </div>
      </nav>

      <div className="container py-4">
        {message.text && (
          <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show mb-3`} role="alert">
            {message.text}
            <button type="button" className="btn-close btn-close-white" onClick={() => setMessage({ type: '', text: '' })}></button>
          </div>
        )}

        {/* Section Villes */}
        <div style={{ background: CARD, borderRadius: '16px', border: `1px solid ${BORDER}`, boxShadow: SHADOW, padding: '20px 24px', marginBottom: '24px' }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="fw-bold mb-0" style={{ color: '#1a3322', fontSize: '18px' }}>
              <i className="fas fa-city me-2" style={{ color: G }}></i>Villes
            </h3>
            <button onClick={() => { setCityForm({ name: '', code: '' }); setShowCityModal(true); }} className="btn btn-sm fw-bold"
              style={{ background: `linear-gradient(135deg, ${G}, ${G_DARK})`, color: '#fff', border: 'none', borderRadius: '8px', padding: '6px 16px' }}>
              <i className="fas fa-plus me-1"></i>Nouvelle ville
            </button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {cities.length === 0 ? (
              <span style={{ color: 'rgba(0,0,0,0.35)', fontSize: '14px' }}>Aucune ville</span>
            ) : cities.map(c => (
              <span key={c.id} style={{ padding: '6px 16px', borderRadius: '20px', background: 'rgba(0,192,96,0.12)', border: `1px solid rgba(0,192,96,0.35)`, color: '#1a3322', fontWeight: 600, fontSize: '13px' }}>
                <i className="fas fa-map-marker-alt me-1" style={{ color: G, fontSize: '11px' }}></i>
                {c.name} <span style={{ color: 'rgba(0,0,0,0.35)', fontWeight: 400 }}>({c.code})</span>
              </span>
            ))}
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fw-bold mb-1" style={{ color: '#1a3322', fontSize: '26px' }}>
              <i className="fas fa-store me-2" style={{ color: G }}></i>Points de Vente
            </h2>
            <p style={{ color: 'rgba(0,0,0,0.5)', margin: 0 }}>{pdvs.length} PDV(s)</p>
          </div>
          <button onClick={handleCreate} className="btn fw-bold"
            style={{ background: `linear-gradient(135deg, ${G}, ${G_DARK})`, color: '#fff', border: 'none', padding: '10px 22px', borderRadius: '10px', boxShadow: '0 4px 14px rgba(0,192,96,0.35)' }}>
            <i className="fas fa-plus me-2"></i>Nouveau PDV
          </button>
        </div>

        <div style={{ background: CARD, borderRadius: '16px', border: `1px solid ${BORDER}`, boxShadow: SHADOW, overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'linear-gradient(135deg, #00C060 0%, #00A651 100%)' }}>
                  {['Nom', 'Code', 'Ville', 'Adresse', 'Statut', 'Actions'].map(h => (
                    <th key={h} style={{ padding: '14px 16px', color: '#1a3322', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: h === 'Statut' || h === 'Actions' ? 'center' : 'left' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pdvs.length === 0 ? (
                  <tr><td colSpan="6" style={{ padding: '50px', textAlign: 'center', color: 'rgba(0,0,0,0.35)' }}>
                    <i className="fas fa-store fa-3x d-block mb-3" style={{ opacity: 0.3, color: G }}></i>
                    Aucun point de vente
                  </td></tr>
                ) : pdvs.map((pdv, idx) => (
                  <tr key={pdv.id} style={{ borderBottom: `1px solid rgba(0,192,96,0.15)`, background: idx % 2 === 0 ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.1)' }}>
                    <td style={{ padding: '14px 16px', color: '#1a3322', fontWeight: 600 }}>{pdv.name}</td>
                    <td style={{ padding: '14px 16px', color: 'rgba(255,255,255,0.7)', fontFamily: 'monospace' }}>{pdv.code}</td>
                    <td style={{ padding: '14px 16px', color: 'rgba(255,255,255,0.7)' }}>{pdv.city?.name || '-'}</td>
                    <td style={{ padding: '14px 16px', color: 'rgba(0,0,0,0.5)', fontSize: '13px' }}>{pdv.address || '-'}</td>
                    <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                      <span style={{ padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 700,
                        background: pdv.is_active ? 'rgba(0,192,96,0.15)' : 'rgba(229,57,53,0.15)',
                        color: pdv.is_active ? '#00A651' : '#e53935',
                        border: `1px solid ${pdv.is_active ? 'rgba(0,192,96,0.4)' : 'rgba(229,57,53,0.4)'}` }}>
                        {pdv.is_active ? 'Actif' : 'Inactif'}
                      </span>
                    </td>
                    <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                      <div className="d-flex gap-2 justify-content-center">
                        <button onClick={() => handleEdit(pdv)}
                          style={{ padding: '6px 12px', background: 'rgba(24,144,255,0.15)', color: '#1890ff', border: '1px solid rgba(24,144,255,0.4)', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                          <i className="fas fa-edit"></i>
                        </button>
                        <button onClick={() => handleDelete(pdv.id)}
                          style={{ padding: '6px 12px', background: 'rgba(229,57,53,0.15)', color: '#e53935', border: '1px solid rgba(229,57,53,0.4)', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showCityModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.7)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ background: '#ffffff', border: `1px solid rgba(0,192,96,0.4)`, borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }}>
              <div className="modal-header" style={{ borderBottom: `1px solid rgba(0,192,96,0.3)`, background: 'rgba(0,0,0,0.3)', borderRadius: '16px 16px 0 0' }}>
                <h5 className="modal-title fw-bold" style={{ color: '#1a3322' }}>
                  <i className="fas fa-city me-2" style={{ color: G }}></i>Nouvelle Ville
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowCityModal(false)}></button>
              </div>
              <div className="modal-body">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div>
                    <label style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px', display: 'block', marginBottom: '6px' }}>Nom *</label>
                    <input type="text" value={cityForm.name} placeholder="Ex: Bafoussam"
                      onChange={e => setCityForm({ ...cityForm, name: e.target.value })}
                      style={inputStyle} />
                  </div>
                  <div>
                    <label style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px', display: 'block', marginBottom: '6px' }}>Code *</label>
                    <input type="text" value={cityForm.code} placeholder="Ex: BFS"
                      onChange={e => setCityForm({ ...cityForm, code: e.target.value.toUpperCase() })}
                      style={inputStyle} />
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={{ borderTop: `1px solid rgba(0,192,96,0.3)` }}>
                <button className="btn fw-bold" onClick={() => setShowCityModal(false)}
                  style={{ background: 'rgba(0,0,0,0.06)', color: '#1a3322', border: '1px solid rgba(0,0,0,0.15)' }}>Annuler</button>
                <button className="btn fw-bold" onClick={handleCreateCity}
                  style={{ background: `linear-gradient(135deg, ${G}, ${G_DARK})`, color: '#fff', border: 'none', padding: '8px 24px', boxShadow: '0 4px 14px rgba(0,192,96,0.3)' }}>
                  <i className="fas fa-save me-2"></i>Créer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.7)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ background: '#ffffff', border: `1px solid rgba(0,192,96,0.4)`, borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }}>
              <div className="modal-header" style={{ borderBottom: `1px solid rgba(0,192,96,0.3)`, background: 'rgba(0,0,0,0.3)', borderRadius: '16px 16px 0 0' }}>
                <h5 className="modal-title fw-bold" style={{ color: '#1a3322' }}>
                  <i className="fas fa-store me-2" style={{ color: G }}></i>
                  {selectedPDV ? 'Modifier le PDV' : 'Nouveau Point de Vente'}
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {[
                    { label: 'Nom *', field: 'name', type: 'text', placeholder: 'Ex: Super Marché Akwa' },
                    { label: 'Code *', field: 'code', type: 'text', placeholder: 'Ex: PDV001' },
                    { label: 'Adresse', field: 'address', type: 'text', placeholder: 'Ex: Rue de la Paix, Douala' },
                  ].map(f => (
                    <div key={f.field}>
                      <label style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px', display: 'block', marginBottom: '6px' }}>{f.label}</label>
                      <input type={f.type} value={formData[f.field]} placeholder={f.placeholder}
                        onChange={e => setFormData({ ...formData, [f.field]: e.target.value })}
                        style={inputStyle} />
                    </div>
                  ))}
                  <div>
                    <label style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px', display: 'block', marginBottom: '6px' }}>Ville *</label>
                    <select value={formData.city_id} onChange={e => setFormData({ ...formData, city_id: e.target.value })} style={inputStyle}>
                      <option value="">Sélectionner une ville</option>
                      {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" checked={formData.has_big_screen} id="bigscreen"
                      onChange={e => setFormData({ ...formData, has_big_screen: e.target.checked })}
                      style={{ width: '18px', height: '18px', accentColor: G }} />
                    <label htmlFor="bigscreen" style={{ color: '#1a3322', fontSize: '14px', margin: 0, cursor: 'pointer' }}>Écran géant</label>
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={{ borderTop: `1px solid rgba(0,192,96,0.3)` }}>
                <button className="btn fw-bold" onClick={() => setShowModal(false)}
                  style={{ background: 'rgba(0,0,0,0.06)', color: '#1a3322', border: '1px solid rgba(0,0,0,0.15)' }}>Annuler</button>
                <button className="btn fw-bold" onClick={handleSave}
                  style={{ background: `linear-gradient(135deg, ${G}, ${G_DARK})`, color: '#fff', border: 'none', padding: '8px 24px', boxShadow: '0 4px 14px rgba(0,192,96,0.3)' }}>
                  <i className="fas fa-save me-2"></i>{selectedPDV ? 'Mettre à jour' : 'Créer'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PDVs;
